export default ({ request }) => ({
  rptCostScmListApi(data = {}) {
    return request({
      url: '/financial/rpt/cost/scm/list',
      method: 'POST',
      data,
    })
  },
})
